import { render } from "./EditCard.vue?vue&type=template&id=b7491016&ts=true"
import script from "./EditCard.vue?vue&type=script&lang=ts"
export * from "./EditCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__